import React from 'react';
import type { User } from '@supabase/supabase-js';
import { AppHeader } from './AppHeader';
import { Tabs, type TabKey } from './Tabs';
import { BottomNav } from './BottomNav';

interface Props {
  user: User;
  active: TabKey;
  onTabChange: (key: TabKey) => void;
  onSignOut: () => void;
  badge?: Partial<Record<TabKey, number>>;
  children: React.ReactNode;
}

export function PageShell({ user, active, onTabChange, onSignOut, badge, children }: Props) {
  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <AppHeader user={user} onSignOut={onSignOut} />
      <Tabs active={active} onChange={onTabChange} badge={badge} />
      <main className="flex-1 max-w-shell w-full mx-auto px-4 md:px-6 pt-5 md:pt-6 pb-24 md:pb-12">
        {children}
      </main>
      <BottomNav active={active} onChange={onTabChange} badge={badge} />
    </div>
  );
}
